import { render } from "./AppBar.vue?vue&type=template&id=63ff4fb8"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"

import "./AppBar.vue?vue&type=style&index=0&id=63ff4fb8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__